module.exports = __webpack_public_path__ + "img/9.6084857c.jpg";